export default __webpack_public_path__ + "static/media/logo.79c30b12.svg";